export default __webpack_public_path__ + "static/media/toledo_1.fab0d98a.png";